import React from 'react';
import { Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import PropTypes from 'prop-types';

import Spinner from '../../assets/svg/spinner';
import FinancialPerformanceChart from './components/FinancialPerformanceChart/FinancialPerformanceChart';
import { currencyFormatter } from '../../utils/helpers/formatting/currencyHelpers';
import { selectDailyTicketsStatus } from '../../redux/dailyTickets/dailyTicketsSlice';

import {
  StyledBoxContainer,
  StyledSummaryBox,
  StyledBox,
  MetricItem,
  MetricLabel,
} from './FinancialPerformanceReport.styles';

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

const FinancialPerformanceReport = ({ dailyTickets }) => {
  const dailyTicketsStatus = useSelector(selectDailyTicketsStatus);
  const isLoading = dailyTicketsStatus === 'loading';

  // Calculate totals directly from daily tickets
  const netSales = dailyTickets.reduce((sum, ticket) => sum + (ticket.net || 0), 0);
  const laborCost = dailyTickets.reduce((sum, ticket) => sum + (ticket.cost || 0), 0);
  const laborCostPercentage = netSales > 0 ? Math.round((laborCost * 100) / netSales) : 0;

  return (
    <StyledBoxContainer>
      {isLoading ? (
        <StyledBox>
          <Spinner />
        </StyledBox>
      ) : (
        <>
          <StyledSummaryBox>
            <MetricItem>
              <MetricLabel variant="body1">Net Sales</MetricLabel>
              <Typography variant="h6">{currencyFormatter(netSales)}</Typography>
            </MetricItem>
            <MetricItem>
              <MetricLabel variant="body1">Labor Cost</MetricLabel>
              <Typography variant="h6">{currencyFormatter(laborCost)}</Typography>
            </MetricItem>
            <MetricItem>
              <MetricLabel variant="body1">Labor Cost % of Revenue</MetricLabel>
              <Typography variant="h6">{laborCostPercentage}%</Typography>
            </MetricItem>
          </StyledSummaryBox>

          <FinancialPerformanceChart dailyTickets={dailyTickets} />
        </>
      )}
    </StyledBoxContainer>
  );
};

FinancialPerformanceReport.propTypes = {
  dailyTickets: PropTypes.arrayOf(
    PropTypes.shape({
      net: PropTypes.number,
      cost: PropTypes.number,
      date: PropTypes.string,
    })
  ).isRequired,
};

export default FinancialPerformanceReport;
